<app-nav-pages></app-nav-pages>

<!-- Hero Section -->
<section
  class="hero-section-new d-flex justify-content-center align-items-center"
  #textContent
  >
  <div class="hero-text-new text-center">
    <h1 class="hero-main-heading">BENIN CITY</h1>
    <p class="hero-subtitle">
      We Are Bringing First-World Development<br />To African Cities
    </p>
  </div>
</section>

<!-- The Journey Section -->
<section class="journey-section" #textContent>
  <div class="journey-container">
    <h2 class="journey-main-heading">
      The Journey to Bringing Development to African<br class="desktop-break" />
      Cities
    </h2>
    <div class="journey-content-wrapper">
      <div class="journey-left">
        <h2 class="value-creation-heading">Value Creation</h2>
      </div>
      <div class="journey-right">
        <p class="journey-text">
          We left the comfort of first-world cities and returned to Africa to
          build because we had seen what was possible and knew our continent
          could rise to that level and even surpass it. Africans, especially
          Nigerians, are talented, hardworking, and full of potential. With the
          right infrastructure and environment, they can thrive anywhere. That
          is why our mission is to bring first-world development to African
          cities.
        </p>
        <a routerLink="/who-we-are/leadership/ceo" class="read-more-btn">
          <span>Read More</span>
          <svg
            class="arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="16"
            viewBox="0 0 13 16"
            fill="none"
            >
            <path
              d="M1.00006 14.2611L9.95122 0.999263L1.00006 14.2611ZM9.95122 0.999263L11.5677 9.32914L9.95122 0.999263ZM9.95122 0.999263L1.62134 2.61577L9.95122 0.999263Z"
              fill="white"
              />
              <path
                d="M1.00006 14.2611L9.95122 0.999263M9.95122 0.999263L11.5677 9.32914M9.95122 0.999263L1.62134 2.61577"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- About Showcase Cards -->
    <section class="showcase-cards-section" #textContent>
      <div class="showcase-cards-container">
        @for (card of aboutShowcaseCards; track card) {
          <article
            class="showcase-card"
      [ngStyle]="{
        'background-image': 'url(' + card.image + ')',
        'background-size': 'cover',
        'background-position': 'center'
      }"
            >
            <!-- Background overlay -->
            <div
              class="showcase-card-overlay"
        [ngStyle]="{
          background: card.gradient
        }"
            ></div>
            <!-- Text content positioned absolutely -->
            <div
              class="showcase-card-text"
        [ngStyle]="{
          top: card.textPosition.top,
          right: card.textPosition.right,
          bottom: card.textPosition.bottom,
          left: card.textPosition.left
        }"
              >
              <h3
                class="showcase-card-title"
          [ngStyle]="{
            right: card.titleRight || '56.76%',
            left: '0',
            top: '0'
          }"
                >
                <span class="title-main">{{ card.title }}</span
                  >@if (card.subtitle) {
                  <span class="showcase-card-subtitle">
                    {{ card.subtitle }}
                  </span>
                }
              </h3>
              <div
                class="showcase-card-content"
          [ngStyle]="{
            top: '23.43%'
          }"
                >
                @for (
                  paragraph of card.title === 'Benin City'
                  ? getBeninCityParagraphs()
                  : card.paragraphs
                  ; track
                  paragraph) {
                  <p
                    class="showcase-card-paragraph"
                    >
                    {{ paragraph }}
                  </p>
                }
                @if (card.title === 'Benin City' && !beninCityExpanded) {
                  <button
                    (click)="toggleBeninCityText()"
                    class="read-more-btn-showcase"
                    >
                    Read More
                  </button>
                }
                @if (card.title === 'Benin City' && beninCityExpanded) {
                  <button
                    (click)="toggleBeninCityText()"
                    class="read-less-btn-showcase"
                    >
                    Read Less
                  </button>
                }
              </div>
            </div>
          </article>
        }
      </div>
    </section>

    <!-- Discover Benin City Section -->
    <section class="discover-section" #textContent>
      <div class="discover-container">
        <h2 class="discover-heading">Discover Benin City</h2>
        <div class="discover-content-wrapper">
          <div class="discover-left">
            <h3 class="zumera-tower-heading">
              Zumera Tower |<br />RJ International<br />Hotel
            </h3>
          </div>
          <div class="discover-right">
            <p class="discover-text">
              Our first development in this mission, the Zumera Tower | RJ
              International Hotel, is a world-class hospitality brand created to
              compete with and surpass international standards. Through it, we are
              defining what true African excellence is and should be. It stands as
              the largest five-star mixed-use project in Nigeria, built with
              first-world architecture, smart technology, and high quality
              materials.
            </p>
            <p class="discover-text">
              Now rising three floors above ground, Zumera Tower is open to
              investors who believe in Africa's power to create destinations that
              can rival the best in the world and who want to be part of Benin
              City's transformation story.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Quote Section -->
    <section class="quote-section" #textContent>
      <div class="quote-container">
        <p class="main-quote">
          "Our mission begins with our people and the communities they call home.
          Every great destination starts with a vision, and every vision requires
          courage, discipline, and creativity to come alive. Africa has the talent,
          resources, and heart to build destinations that stand proudly beside the
          world's best. We are here to make that happen."
        </p>
        <p class="quote-author">
          — Lucky R. Erherha, Founder & CEO, Zumera Property
        </p>
        <a
          href="https://www.zumerainvestment.com/become-a-shareholder"
          target="_blank"
          rel="noopener noreferrer"
          class="shareholder-btn"
          >Become a Shareholder</a
          >
        </div>
      </section>

      <app-footer class="w-100 d-none d-sm-block"></app-footer>
      <app-footer-sm class="w-100 d-sm-none"></app-footer-sm>
